import { API_ENDPOINT, STORAGE } from "../constants";
import { HTTP } from "./http";
import { StorageService } from "./storage";

export const LoanCreditsService = {
  save: (
    name: string,
    _id?: string,
    // account?: string,
    status?: boolean
  ) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.post<any, any>(`${API_ENDPOINT}loan-credits`, { _id, account, name, status });
  },
  list: () => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.get<any, any>(`${API_ENDPOINT}loan-credits/${account}`);
  },
}